import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import {
  Web3GameIcon,
  DesignIcon,
  LaunchIcon,
  Web3GameBlockchain,
  PlaneIcon,
  TestIcon,
} from "../../../app-constants";

import { Link } from "gatsby";

const WorkFlow = [
  {
    logo: PlaneIcon,
    title: "Plan",
    description:
      "We start with writing the game goals and create a scope document that outlines the specific Web3 game’s story and characters for player experience, list of features and wireframes for development execution, technology stack and monetization framework for development roadmap.",
    count: "01",
  },
  {
    logo: DesignIcon,
    title: "Design",
    description:
      "The design stage starts with a smooth hand-off to the UI/UX and game designers. These teams work together to create the brand-centric style concept and guides, create assets, illustrate characters, environments and animations, then complete the frontend user interface mockups.",
    count: "02",
  },
  {
    logo: Web3GameIcon,
    title: "Game Development",
    description:
      "After UI/UX and game art completion, we start with the game application architecture and initiate with frontend development, backend development and database setups. The backend department integrates API, payment methods and complete documentation necessary for wallets and smart contracts.",
    count: "03",
  },
  {
    logo: Web3GameBlockchain,
    title: "Blockchain Integration",
    description:
      "During this stage, we code on either Rust or Solana. Because Web3 games use decentralized finances, mini-models of NFT marketplaces, NFTs, cryptocurrencies and/or tokens, we code the architecture separately then integrate in form of smart contracts depending on the game’s technical requirements.",
    count: "04",
  },
  {
    logo: TestIcon,
    title: "Test",
    description:
      "After wallet integration, smart contracts execution and NFT transactions implementation, we conduct thorough game tests to assess them on five technical and experiential fronts: functionality, performance, data security, device compatibility, and data handling.",
    count: "05",
  },
  {
    logo: LaunchIcon,
    title: "Launch and Maintenance",
    description:
      "After battle-testing the quality of the game, we create listing information, follow the go-to-market strategies and launch the games on pre-decided platforms. We create landing pages for soft and hard launches, monitor early-stage user onboarding and document performance, bugs, errors and fixes.",
    count: "06",
  },
];
const Workflow = () => {
  return (
    <div className="workflow web3_game_process p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={7}
            xxl={7}
            className="m-auto text-center"
          >
            <h2>
              Web3 Game Development <span>Process at TekRevol</span>
            </h2>
            <p>
              We have a flagship game development process based on agile
              methodologies and follows sprints closely. The technical lead, art
              director and head project manager deputed on your Web3 game
              collaborate to divide execution tasks into sprints – with each one
              spanning across 6 to 8 business days. Take an insider look into
              how we do what we do! 
            </p>
          </Col>
        </Row>
        <Row className="workflow_secion">
          {WorkFlow.map((item, index) => (
            <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="my-auto">
              <div className="workflow_items">
                <div className="item_name">
                  <span>{item.count}</span>
                  {item.title}
                  <div className="item_icon"> {item.logo}</div>
                </div>
                <p>{item.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default Workflow;
